// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"386":"faqs","406":"newlist"}[chunkId] + "." + {"386":"89af260b","406":"17bec430"}[chunkId] + ".css";
};